import { CityPos } from 'types/global';
export const citySize = 5;
export const mapSizeX = 100;
export const mapSizeY = 100;
export const initIndex = 5555;
export const limitOneVal = 10000;
export const limitTwoVal = 100000;
export const limitThreeVal = 1000000;
export const cityPos: Array<CityPos> = [
  {
    name: 'test11',
    pos: [-2.45, 0.5, -0.36],
  },
  {
    name: 'test12',
    pos: [-2.45, 0.5, -0.36],
  },
  {
    name: 'test21',
    pos: [-1, 0.5, -0.36],
  },
  {
    name: 'test22',
    pos: [-0.3, 0.5, -0.36],
  },
  {
    name: 'test23',
    pos: [0.4, 0.5, -0.36],
  },
  {
    name: 'test31',
    pos: [-1, 0.5, 1],
  },
  {
    name: 'test32',
    pos: [-0.3, 0.5, 1],
  },
  {
    name: 'test33',
    pos: [0.4, 0.5, 1],
  },
  {
    name: 'test41',
    pos: [-1, 0.5, 1.75],
  },
  {
    name: 'test42',
    pos: [-1, 0.5, 2.5],
  },
  {
    name: 'test51',
    pos: [0.4, 0.5, 1.75],
  },
  {
    name: 'test52',
    pos: [-1, 0.5, 2.5],
  },
  {
    name: 'test61',
    pos: [1.7, 0.5, -0.36],
  },
  {
    name: 'test62',
    pos: [1.7, 0.5, 1],
  },
];
